import { memo, useEffect, useCallback, useState } from "react";
import Form from "../../components/Form.js";
import Table from "../../components/Table.js";
import { useSnackbar } from "../../utils/index.js";
import Spinner from "../../components/Spinner.js";
import { Box, Typography, Grid2, Button } from "@mui/material";
import { getOwners, getScrapieWithStatus } from "../../api/index.js";
import useSelectStyles from "../../components/styles/Select.js";
import useListStyles from "../../components/styles/List.js";
import {
    registrationCodeHeaderNoClick,
    birthDateHeaderNotFilterable,
    sexHeaderNoFilter,
    sampleNumberHeader,
    firstResultHeader,
    secondResultHeader,
    authenticityHeader,
    sampleDateHeader,
    resultDateHeader,
} from "../../components/TableHeaders.js";

const ViewScrapie = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [fetchedOwners, setFetchedOwners] = useState([]);
    const [ownersDropdownValues, setOwnersDropdownValues] = useState([]);
    const [step, setStep] = useState(1);
    const [selectedOwner, setSelectedOwner] = useState(null);
    const [fetchedScrapies, setFetchedScrapies] = useState([]);

    const listClasses = useListStyles();
    const selectClasses = useSelectStyles();
    const { error } = useSnackbar();

    const fetchData = useCallback(async () => {
        setIsLoading(true);
        try {
            const { owners } = await getOwners();
            setFetchedOwners(owners);
            setOwnersDropdownValues(
                owners.map((owner) => ({
                    value: `${owner?.lastName} ${owner?.firstName} - ${owner?.code}`,
                    text: `${owner?.lastName} ${owner?.firstName} - ${owner?.code}`,
                }))
            );
        } catch (err) {
            error(err);
        }
        setIsLoading(false);
    });

    useEffect(() => {
        fetchData();
    }, []);

    const ownerStatusFormContent = [
        {
            customType: "dropdown",
            id: "owner",
            items: ownersDropdownValues,
            placeholder: "Εκτροφή",
            required: true,
        },
        {
            customType: "dropdown",
            id: "status",
            items: [
                { value: "Λίστα Ζωντανών Ζώων", text: "Λίστα Ζωντανών Ζώων" },
                { value: "Λίστα Νεκρών Ζώων", text: "Λίστα Νεκρών Ζώων" },
            ],
            placeholder: "Κατηγορία",
            required: true,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Υποβολή",
        },
    ];

    const tableColumns = [
        registrationCodeHeaderNoClick,
        birthDateHeaderNotFilterable,
        sexHeaderNoFilter,
        sampleNumberHeader,
        firstResultHeader,
        secondResultHeader,
        authenticityHeader,
        sampleDateHeader,
        resultDateHeader,
    ];

    const handleOwnerStatusSelect = async (values) => {
        setIsLoading(true);
        const selOwner = fetchedOwners.find(
            (owner) => `${owner?.lastName} ${owner?.firstName} - ${owner?.code}` === values.owner
        );
        setSelectedOwner(selOwner);
        let st
        if (values.status === "Λίστα Ζωντανών Ζώων") {
            st = "alive";
        }
        else if (values.status === "Λίστα Νεκρών Ζώων") {
            st = "dead";
        }
        const { success: scs, scrapies, message } = await getScrapieWithStatus(selOwner._id, st);
        if (scs) {
            setFetchedScrapies(scrapies);
            setStep(2);
        } else {
            error(message);
        }
        setIsLoading(false);
    }

    return (
        <>
            <Spinner open={isLoading} />
            {step === 1 && (
                <Box className={selectClasses.outerBox}>
                    <Box container flexDirection="column" className={selectClasses.innerBox}>
                        <Typography variant="h5" sx={{ margin: "1rem" }}>
                            Επιλέξτε την Εκτροφή και την κατηγορία που σας ενδιαφέρει:
                        </Typography>
                        <Form
                            content={ownerStatusFormContent}
                            onSubmit={handleOwnerStatusSelect}
                            toResetForm={true}
                        />
                    </Box>
                </Box>
            )}
            {step === 2 && (
                <Grid2 container className={listClasses.container} direction="column" sx={{ marginTop: "1rem", display: "flex", alignItems: "center" }}>
                    <Box display="flex" justifyContent="center" alignItems="center" sx={{ width: "90%", marginBottom: "1rem" }}>
                        <Typography variant="h5" className={listClasses.form_title} sx={{ display: "flex", alignItems: "center" }}>
                            {`Εμφάνιση Στοιχείων SCRAPIE για τη μονάδα ${selectedOwner?.lastName} ${selectedOwner?.firstName}`}
                        </Typography>
                    </Box>
                    <Table
                        data={fetchedScrapies}
                        noDataText={isLoading ? "Φόρτωση..." : "Δεν υπάρχουν Εγγραφές!"}
                        columns={tableColumns}
                        defaultSorted={[{ id: "birthDate", desc: true }]}
                    />
                </Grid2>
            )}
            {step !== 1 && (
                <Box sx={{ width: "100%", marginTop: "2rem", display: "flex", justifyContent: "center" }}>
                    <Button variant="outlined" color="secondary" onClick={() => setStep(step - 1)}>
                        Πίσω
                    </Button>
                </Box>
            )}
        </>
    )
}

export default memo(ViewScrapie);